/** @format */

import {
  UserOutlined,
  LockOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import React, { useState } from "react";
import swal from "sweetalert";
import NewLogo from "../../icons/logoNew.png";
import MyLogo from "../../icons/Logoraqamlashtirish-02.png";
import { getEnv } from "../../lib/env";

async function loginUser(credentials) {
  return fetch(getEnv('REACT_APP_BASE_URL') + "/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  }).then((data) => data.json());
}

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [fillUsername, setFillUsername] = useState("");
  const [fillPasswd, setFillPasswd] = useState("");
  const [counter, setCounter] = useState(
    Number(localStorage.getItem("login_attempts")) || 0,
  );
  const [blockedUntil, setBlockedUntil] = useState(
    Number(localStorage.getItem("login_block_until")) || 0,
  );

  const submitLoginHandler = async (e) => {
    e.preventDefault();

    if (blockedUntil && Date.now() < blockedUntil) {
      const minutes = Math.ceil((blockedUntil - Date.now()) / 60000);
      swal(
        "Bloklangan",
        `5 daqiqa kuting. Qolgan vaqt: ${minutes} minut`,
        "warning",
      );
      return;
    }

    const response = await loginUser({
      username,
      password,
    });

    if (response.token) {
      swal("Muvaffaqiyatli", "Login va parol to'g'ri", "success", {
        buttons: false,
        timer: 2000,
      }).then(() => {
        localStorage.removeItem("login_attempts");
        localStorage.removeItem("login_block_until");

        localStorage.setItem("sw_user_token", response.token);
        localStorage.setItem("sw_user", JSON.stringify(response));

        window.location.href = "/";
      });
    } else if (response.prokuratura) {
      swal("Kirish rad etildi", response.prokuratura[0], "error");
    } else {
      const newCount = counter + 1;
      setCounter(newCount);
      localStorage.setItem("login_attempts", newCount);

      if (newCount >= 5) {
        const blockTime = Date.now() + 5 * 60 * 1000;

        localStorage.setItem("login_block_until", blockTime);
        setBlockedUntil(blockTime);

        swal(
          "Bloklandi",
          "5 marta xato kiritdingiz. 5 daqiqaga bloklandingiz",
          "error",
        );
      } else {
        swal(
          "Xato",
          `Login yoki parol noto'g'ri. Qolgan urinishlar: ${5 - newCount}`,
          "error",
        );
      }
    }
  };

  return (
    <div className="container__login">
      <div className="screen">
        <div className="screen__content">
          <img src={NewLogo} alt="logo" className="login__logo" />
          <form className="login" onSubmit={submitLoginHandler}>
            <div className="login__field">
              <UserOutlined className="login__icon" />
              <input
                type="text"
                className="login__input"
                placeholder="Foydalanuvchi nomi"
                onInput={(e) => setUsername(e.target.value)}
              />
              <p className="login__error">{fillUsername}</p>
            </div>

            <div className="login__field">
              <LockOutlined className="login__icon" />
              <input
                type="password"
                className="login__input"
                placeholder="Parol"
                onInput={(e) => setPassword(e.target.value)}
              />
              <p className="login__error">{fillPasswd}</p>
            </div>

            <button disabled={blockedUntil && Date.now() < blockedUntil} className="login__submit" type="submit">
              Kirish <ArrowRightOutlined />
            </button>
          </form>
        </div>

        <div className="login__visual">
          <img src={MyLogo} alt="my-logo" />
        </div>
      </div>
    </div>
  );
};

export default Login;
